import { ILectioPlugin } from './Types';

export class PluginEnsureEditElementInView implements ILectioPlugin {
	public Init(): void {
		CKEDITOR.plugins.add('lectioEnsureEditElementInView', {
			init: (editor: CKEDITOR.editor) => {
				editor.on("afterCommandExec", evt => {
					if (!evt || !evt.editor)
						return;
					const selection = evt.editor.getSelection();
					if (!selection)
						return;

					const curelement = selection.getStartElement();
					if (!curelement)
						return;

					try {
						curelement.scrollIntoView();
					} catch (e) {

					}

				});
			}
		});
	}
}
